import { render, staticRenderFns } from "./Alibaba-bill.vue?vue&type=template&id=bcfd59ca&scoped=true&"
import script from "./Alibaba-bill.vue?vue&type=script&lang=js&"
export * from "./Alibaba-bill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfd59ca",
  null
  
)

export default component.exports